import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { size, COLORS } from "../../utils";
import styles from "./Workshops.module.css";

export default function Workshops() {

  return (
    <Grid
      item
      container
      direction="column"
      alignItems="center"
      m={`${size({ p: 15, h: true })} 0px`}
      rowGap={size({ p: 5, h: true })}
      padding={`0px ${size({ p: 10 })}`}
      className={styles.container}
    >
      {/* Heading Section */}
      <Grid item container direction="column" rowGap={size({ p: 2, h: true })}>
        <Grid item>
          <Typography
            sx={{
              fontFamily: "Archia",
              fontSize: {
                xs: size({ p: 1.5 }), // smaller font on mobile
                sm: size({ p: 2.2 }),
              },
              fontWeight: 600,
              textAlign: "center",
              color: COLORS.C1,
              padding: `0px ${size({ p: 5 })}`,
            }}
            className={styles["workshop-title"]}
          >
            We offer a diverse array of workshops covering both emerging and
            existing technologies with our comprehensive offerings
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            sx={{
              fontFamily: "Archia",
              fontSize: {
                xs: size({ p: 0.8 }),
                sm: size({ p: 1 }),
              },
              fontWeight: 400,
              textAlign: "center",
              color: `${COLORS.C1}A0`,
              padding: {
                xs: `0px ${size({ p: 2 })}`,
                sm: `0px ${size({ p: 2 })}`,
              },
            }}
            className={styles["workshop-description"]}
          >
            Start your learning adventure with our diverse selection of
            workshops on today's hottest technologies. Embark on a journey of
            continuous learning with our diverse range of workshops,
            meticulously curated to cover both emerging and established
            technologies. Elevate your skills and stay ahead in the dynamic
            world of technology with our immersive and hands-on sessions. Embark
            on a transformative learning adventure with our array of workshops,
            carefully curated to cover the hottest technologies of today.
            Explore hands-on sessions, dive deep into emerging trends, and
            ignite your passion for continuous learning. Join us to stay at the
            forefront of the ever-evolving tech landscape.
          </Typography>
        </Grid>
      </Grid>

      {/* Association With Title */}
      <Grid
        item
        container
        direction="column"
        alignItems="center"
        rowGap={size({ p: 1, h: true })}
      >
        <Grid item>
          <Typography
            sx={{
              fontFamily: "Archia",
              fontSize: {
                xs: size({ p: 1.5 }),
                sm: size({ p: 2.2 }),
              },
              fontWeight: 700,
              color: COLORS.C1,
            }}
            className={styles["workshop-association"]}
          >
            In Association With
          </Typography>
        </Grid>

        {/* 5-Column Grid Layout */}
        <Box
          sx={{
            width: {
              xs: "100%", // full width on mobile
              sm: "60rem",
            },
            height: {
              xs: "auto", // height adjusts on mobile
              sm: "30rem",
            },
            backgroundColor: "#d6d5d5ff",
            borderRadius: "1.5rem",
            padding: {
              xs: "1rem 1rem 2rem 1rem",
              sm: "3rem",
            },
            mt: "1.5rem",
            overflowX: {
              xs: "auto",  // scrollbar on mobile only
              sm: "visible", // no scrollbar on desktop
            },
          }}
        >
          {/* Row 1 */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: "1.5rem",
              flexWrap: {
                xs: "wrap", // wrap images on mobile
                sm: "nowrap",
              },
              gap: {
                xs: "1rem",
                sm: "2rem",
              },
            }}
          >
            {/* Image 1 */}
            <Box
              component="img"
              src="/assets/images/workshops/pu.svg"
              alt="pu"
              sx={{
                width: {
                  xs: "80px",
                  sm: "110px",
                },
                height: {
                  xs: "80px",
                  sm: "110px",
                },
              }}
            />
            {/* Image 2 */}
            <Box
              component="img"
              src="/assets/images/workshops/panimalar.png"
              alt="panimalar"
              sx={{
                width: {
                  xs: "80px",
                  sm: "110px",
                },
                height: {
                  xs: "80px",
                  sm: "110px",
                },
              }}
            />
            {/* Image 3 */}
            <Box
              component="img"
              src="/assets/images/workshops/SMVEC.svg"
              alt="SMVEC"
              sx={{
                width: {
                  xs: "180px",
                  sm: "370px",
                },
                height: {
                  xs: "80px",
                  sm: "110px",
                },
              }}
            />
            {/* Image 4 */}
            <Box
              component="img"
              src="/assets/images/workshops/mit.png"
              alt="mit"
              sx={{
                width: {
                  xs: "80px",
                  sm: "110px",
                },
                height: {
                  xs: "80px",
                  sm: "110px",
                },
              }}
            />
          </Box>

          {/* Row 2 */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: "1.5rem",
              flexWrap: {
                xs: "wrap",
                sm: "nowrap",
              },
              gap: {
                xs: "1rem",
                sm: "2rem",
              },
            }}
          >
            {/* Image 1 */}
            <Box
              component="img"
              src="/assets/images/workshops/saradha.svg"
              alt="saradha"
              sx={{
                width: {
                  xs: "80px",
                  sm: "110px",
                },
                height: {
                  xs: "80px",
                  sm: "110px",
                },
              }}
            />
            {/* Image 2 */}
            <Box
              component="img"
              src="/assets/images/workshops/raak.svg"
              alt="raak"
              sx={{
                width: {
                  xs: "80px",
                  sm: "110px",
                },
                height: {
                  xs: "80px",
                  sm: "110px",
                },
              }}
            />
            {/* Image 3 */}
            <Box
              component="img"
              src="/assets/images/workshops/aasc.svg"
              alt="aasc"
              sx={{
                width: {
                  xs: "140px",
                  sm: "230px",
                },
                height: {
                  xs: "80px",
                  sm: "110px",
                },
              }}
            />
            {/* Image 4 */}
            <Box
              component="img"
              src="/assets/images/workshops/apec.png"
              alt="apec"
              sx={{
                width: {
                  xs: "80px",
                  sm: "110px",
                },
                height: {
                  xs: "80px",
                  sm: "110px",
                },
              }}
            />
            {/* Image 5 */}
            <Box
              component="img"
              src="/assets/images/workshops/gpc.png"
              alt="gpc"
              sx={{
                width: {
                  xs: "80px",
                  sm: "110px",
                },
                height: {
                  xs: "80px",
                  sm: "110px",
                },
              }}
            />
          </Box>

          {/* Row 3 */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: "1rem",
              flexWrap: {
                xs: "wrap",
                sm: "nowrap",
              },
              gap: {
                xs: "1rem",
                sm: "2rem",
              },
            }}
          >
            {/* Image 1 */}
            <Box
              component="img"
              src="/assets/images/workshops/rajivgandhi.svg"
              alt="rajivgandhi"
              sx={{
                width: {
                  xs: "80px",
                  sm: "110px",
                },
                height: {
                  xs: "80px",
                  sm: "110px",
                },
              }}
            />
            {/* Image 2 */}
            <Box
              component="img"
              src="/assets/images/workshops/mailam.svg"
              alt="mailam"
              sx={{
                width: {
                  xs: "140px",
                  sm: "230px",
                },
                height: {
                  xs: "80px",
                  sm: "110px",
                },
              }}
            />
            {/* Image 3 */}
            <Box
              component="img"
              src="/assets/images/workshops/next1.svg"
              alt="Example"
              sx={{
                width: {
                  xs: "80px",
                  sm: "110px",
                },
                height: {
                  xs: "80px",
                  sm: "110px",
                },
              }}
            />
            {/* Image 4 */}
            <Box
              component="img"
              src="/assets/images/workshops/bgcw.svg"
              alt="bgcw"
              sx={{
                width: {
                  xs: "80px",
                  sm: "110px",
                },
                height: {
                  xs: "80px",
                  sm: "110px",
                },
              }}
            />
            {/* Image 5 */}
            <Box
              component="img"
              src="/assets/images/workshops/next2.svg"
              alt="Example"
              sx={{
                width: {
                  xs: "80px",
                  sm: "110px",
                },
                height: {
                  xs: "80px",
                  sm: "110px",
                },
              }}
            />
          </Box>
        </Box>
      </Grid>

    </Grid>
  );
}
